import { cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
interface LegacyDataTableHeaderProps {
    className?: string;
    children?: React.ReactNode;
}
export function LegacyDataTableHeader({ className, children }: LegacyDataTableHeaderProps): React.ReactElement {
    return <thead className={cx(styles.dataTableHeader, className)}>{children}</thead>;
}
